export default __webpack_public_path__ + "30e603067ada4d23be2cddf16b91e29d.png";